export const PYLON_RESOURCES_LAUNCH_PATH = "/resources/launching";

const PYLON_SSO_ORIGIN = "https://graph.usepylon.com";
const PYLON_SSO_PATH = "/callback/jwt";

/** Mirrors server/utils/pylonSso.js `PYLON_SSO_LIFETIME_SECONDS`. */
export const PYLON_SSO_LIFETIME_MS = 120_000;
const PYLON_SSO_EXPIRY_SKEW_MS = 15_000;

export const isPylonSsoUrl = (value: string): boolean => {
  try {
    const url = new URL(value);
    return (
      url.origin === PYLON_SSO_ORIGIN &&
      url.pathname === PYLON_SSO_PATH &&
      !url.username &&
      !url.password &&
      Boolean(url.searchParams.get("orgSlug")) &&
      Boolean(url.searchParams.get("jwt"))
    );
  } catch {
    return false;
  }
};

export const toTrustedPylonSsoUrl = (value: string): string | null =>
  isPylonSsoUrl(value) ? value : null;

export const isPylonSsoMintFresh = (mintedAtMs: number, nowMs = Date.now()): boolean =>
  nowMs + PYLON_SSO_EXPIRY_SKEW_MS < mintedAtMs + PYLON_SSO_LIFETIME_MS;

export const getPylonSsoRefreshDelayMs = (mintedAtMs: number, nowMs = Date.now()): number =>
  Math.max(0, mintedAtMs + PYLON_SSO_LIFETIME_MS - PYLON_SSO_EXPIRY_SKEW_MS - nowMs);

export const openPendingPylonTab = (): Window | null => {
  try {
    const pendingTab = window.open("about:blank", "_blank");
    if (!pendingTab || pendingTab.closed) {
      return null;
    }

    return pendingTab;
  } catch {
    return null;
  }
};

export const closePendingPylonTab = (pendingTab: Window | null): void => {
  if (!pendingTab || pendingTab.closed) {
    return;
  }

  pendingTab.close();
};

export const openPylonSsoUrl = (url: string, pendingTab: Window | null = null): boolean => {
  const trustedUrl = toTrustedPylonSsoUrl(url);
  if (!trustedUrl) {
    closePendingPylonTab(pendingTab);
    return false;
  }

  if (pendingTab && !pendingTab.closed) {
    pendingTab.location.replace(trustedUrl);
    pendingTab.opener = null;
    return true;
  }

  window.open(trustedUrl, "_blank", "noopener,noreferrer");
  return true;
};
